import React, { Component } from "react";
import moment from "moment";
import Session from "./Session";
import _ from "lodash";
class Cinema extends Component {
  state = {
    visible: false
  };

  render() {
    const grouped = _.groupBy(this.props.showtimes, o =>
      moment(o.start_at).format("DD/MM/YYYY")
    );

    const sessions = _.map(grouped, (sessions, day) => (
      <div key={day} className="day">
        <div>{day}</div>
        <div className="cinema__sessions">
          {sessions.map(o => (
            <Session
              key={o.id}
              link={o.booking_link}
              time={moment(o.start_at.split("+")[0]).format("HH:mm")}
            />
          ))}
        </div>
      </div>
    ));

    return (
      <div className="cinema">
        <div
          className="cinema__header"
          onClick={() => {
            this.setState(previousState => {
              const visible = !previousState.visible;
              return { visible };
            });
          }}
        >
          <span>
            {this.props.cinema.name || this.props.cinema.title || this.props.cinema.slug}
          </span>
          {" (" + this.props.showtimes.length + " showtimes)"}
          <i
            className={
              "fas " +
                (this.state.visible ? "fa-chevron-up" : "fa-chevron-down")
            }
          />
        </div>
        <div
          className={
            this.state.visible
              ? "cinema__showtimes"
              : "cinema__showtimes cinema__showtimes--colapsed"
          }
        >
          <div className="cinema__days">
            {sessions}
          </div>
        </div>
      </div>
    );
  }
}

export default Cinema;



// WEBPACK FOOTER //
// ./src/components/Cinema.js